import createSlice from "admin/store/create-slice";
import initialState from "admin/store/initial-state-schema";
import { getApiUrl } from 'shared-kernel/helpers';

const name = 'specialorder';

const slice = createSlice({
    name,
    initialState,
    reducers: {
        requested: state => ({
            ...state,
            isFetching: true
        }),
        failed: state => ({
            ...state,
            isFetching: false,
            isFailed: true
        }),
        itemsReceived: (state, payload) => ({
            ...state,
            isFetching: false,
            items: payload.data.items,
            total: payload.data.total
        }),
        deleteReceived: state => ({
            ...state,
            isFetching: false
        })
    }
});

const { requested, failed, itemsReceived, deleteReceived } = slice.actions;

export default slice.reducer;

export const getAll = data => ({
    types: [requested.type, itemsReceived.type, failed.type],
    method: 'post',
    url: getApiUrl(name, 'getall'),
    payload: data
});

export const remove = ids => ({
    types: [requested.type, deleteReceived.type, failed.type],
    method: 'post',
    url: getApiUrl(name, 'delete'),
    payload: ids
});